export type UserRole = 'admin' | 'moderator' | 'viewer';

export interface RolePermissions {
  canManageTeam: boolean;
  canManageRequests: boolean;
  canViewAnalytics: boolean;
  canManageSettings: boolean;
  canAssignRequests: boolean;
  canChangeRequestStatus: boolean;
}

export const ROLE_PERMISSIONS: Record<UserRole, RolePermissions> = {
  admin: {
    canManageTeam: true,
    canManageRequests: true,
    canViewAnalytics: true,
    canManageSettings: true,
    canAssignRequests: true,
    canChangeRequestStatus: true,
  },
  moderator: {
    canManageTeam: false,
    canManageRequests: true,
    canViewAnalytics: true,
    canManageSettings: false,
    canAssignRequests: true,
    canChangeRequestStatus: true,
  },
  viewer: {
    canManageTeam: false,
    canManageRequests: false,
    canViewAnalytics: true,
    canManageSettings: false,
    canAssignRequests: false,
    canChangeRequestStatus: false,
  },
};

export const hasPermission = (userRole: UserRole, permission: keyof RolePermissions): boolean => {
  return ROLE_PERMISSIONS[userRole]?.[permission] || false;
};

export const canAccessRoute = (userRole: UserRole, route: string): boolean => {
  switch (route) {
    case '/admin/team':
      return hasPermission(userRole, 'canManageTeam');
    case '/admin/settings':
      return hasPermission(userRole, 'canManageSettings');
    case '/admin':
    case '/admin/requests':
      return hasPermission(userRole, 'canManageRequests');
    default:
      return true;
  }
};

export const getRoleDisplayName = (role: UserRole): string => {
  switch (role) {
    case 'admin': return 'Admin';
    case 'moderator': return 'Moderator';
    case 'viewer': return 'Viewer';
    default: return role;
  }
};

export const getRoleBadgeColor = (role: UserRole): string => {
  switch (role) {
    case 'admin': return 'bg-red-100 text-red-800';
    case 'moderator': return 'bg-blue-100 text-blue-800';
    case 'viewer': return 'bg-gray-100 text-gray-800';
    default: return 'bg-gray-100 text-gray-800';
  }
}; 